module.exports = __webpack_public_path__ + "static/media/become-a-respondent.fc43f980.svg";